import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-1 items-start lg:items-end flex flex-col lg:flex-row gap-3 mt-3" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row gap-1"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row gap-1"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "my-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row items-center gap-4 text-gray-400 justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Este registro no cuenta con información disponible.", -1)

import { computed, onMounted, ref, Ref } from "vue";
import { InvestmentService } from "@/services/invest/investmentService";
import { Investment, Record } from "@/services/invest/types";
import { toBadgeFormat, toBadgeFormatUf } from "@/services/utils";

import NewModal from "@/components/atoms/Modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewInvestimentModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  invest: {
    type: Investment,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const investimentService = new InvestmentService();
const records: Ref<Record[]> = ref([]);
const allFieldsAreInvisible = computed(
  () =>
    props.invest.value ||
    props.invest.description ||
    props.invest.id ||
    props.invest.investmentType ||
    props.invest.thumbnail ||
    props.invest.monthlyProfitabilityClp ||
    props.invest.monthlyProfitabilityUf
);

async function getInvestiment() {
  let result = null;
  try {
    if (props.invest.id) {
      result = await investimentService.getRecords(props.invest.id);
      records.value = result.data;
    }
  } catch (error) {
    console.log(error);
  }
  return result;
}

onMounted(() => {
  getInvestiment();
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NewModal, {
      title: 'Registros y detalle de: ' + __props.invest?.title,
      visible: __props.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (__props.invest.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_mdicon, {
                  name: "sack",
                  size: "22"
                }),
                _createTextVNode(" Valor de compra: UF " + _toDisplayString(_unref(toBadgeFormat)(__props.invest.value)), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.invest.monthlyProfitabilityClp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_mdicon, {
                  name: "cash",
                  size: "22"
                }),
                (__props.invest.monthlyProfitabilityClp)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Renta: $" + _toDisplayString(_unref(toBadgeFormat)(__props.invest.monthlyProfitabilityClp ?? 0)) + " mes ", 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, " Renta: UF " + _toDisplayString(_unref(toBadgeFormatUf)(__props.invest.monthlyProfitabilityUf ?? 0)), 1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.invest?.description), 1),
        (!_unref(allFieldsAreInvisible))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_mdicon, { name: "information" }),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}
}

})